import { fetchFaqLogic } from './fetchFaqLogic';

export const logic = [fetchFaqLogic];
